/**  @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { Boundary } from '@floating-ui/react';

import { Typography2 } from '@coursera/cds-core';

import { TooltipWrapper } from 'bundles/common/components/Tooltip';
import type { Placement } from 'bundles/common/components/Tooltip';

const styles = {
  modernTooltip: css`
    background-color: black;
    opacity: 0.8;
    border-radius: var(--cds-border-radius-100);
  `,
  message: css`
    padding: 0 var(--cds-spacing-50);
  `,
};

type Props = {
  message: string | React.ReactNode;
  keyboardShortcut?: string;
  secondaryKeyboardShortcut?: string;
  placement?: Placement;
  className?: string;
  offset?: number;
  videoBoundaryElement?: Boundary;
  children: React.ReactNode;
};

const ModernTooltipWrapper = ({
  message,
  keyboardShortcut,
  secondaryKeyboardShortcut,
  placement = 'top',
  className = 'modern-tooltip-wrapper',
  offset = 25,
  videoBoundaryElement,
  children,
}: Props) => {
  const messageComponent = (
    <Typography2
      component="span"
      variant="bodySecondary"
      color="invertBody"
      data-testid="modern-tooltip-message"
      css={styles.message}
    >
      {message} {keyboardShortcut && <strong>({keyboardShortcut})</strong>}
      {secondaryKeyboardShortcut && (
        <React.Fragment>
          {' '}
          <strong>({secondaryKeyboardShortcut})</strong>
        </React.Fragment>
      )}
    </Typography2>
  );

  return (
    <TooltipWrapper
      data-testid="modern-tooltip-wrapper"
      placement={placement}
      tooltipClassName={className}
      message={messageComponent}
      tooltipCss={styles.modernTooltip}
      offset={offset}
      enableArrow={false}
      boundaryElement={videoBoundaryElement}
      boundaryElementMargin={8}
    >
      {children}
    </TooltipWrapper>
  );
};

export default ModernTooltipWrapper;
